var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as pdfjsLib from "pdfjs-dist";
pdfjsLib.GlobalWorkerOptions.workerSrc =
    "/typo3conf/ext/ewi_flipbook/Resources/Public/JavaScript/pdf.worker.bundle.js";
function initializeFlipBook(el) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var pdfUrl, pdf, header, name, paging, download;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    el.classList.add("pdf-flipbook");
                    pdfUrl = el.getAttribute("data-pdf-view");
                    if (!pdfUrl) {
                        throw new Error("data-pdf-view needs to contain a valid URL");
                    }
                    return [4 /*yield*/, pdfjsLib.getDocument(pdfUrl).promise];
                case 1:
                    pdf = _b.sent();
                    header = document.createElement("div");
                    header.classList.add("pdf-header");
                    name = document.createElement("span");
                    name.innerText = el.getAttribute("data-pdf-name") + " | Seite ";
                    paging = document.createElement("span");
                    download = document.createElement("a");
                    download.href = el.getAttribute("data-pdf-view") || "";
                    download.target = "_blank";
                    download.innerHTML =
                        'Dokument herunterladen <i class="icon icon-download"></i>';
                    header.append(name, paging, download);
                    (_a = el.parentElement) === null || _a === void 0 ? void 0 : _a.insertBefore(header, el);
                    renderBook(pdf, el, paging);
                    return [2 /*return*/];
            }
        });
    });
}
function createPageCanvas(cls) {
    var page = document.createElement("div");
    page.classList.add(cls);
    var canvas = document.createElement("canvas");
    canvas.classList.add("main");
    var loadingIndicator = document.createElement("div");
    loadingIndicator.classList.add("loading-indicator");
    loadingIndicator.innerHTML = "<div class=\"loading-spinner\"><div></div><div></div><div></div><div></div></div>";
    page.append(canvas);
    page.append(loadingIndicator);
    return { page: page, canvas: canvas };
}
function renderBook(pdf, el, paging, currentPage) {
    if (currentPage === void 0) { currentPage = 1; }
    return __awaiter(this, void 0, void 0, function () {
        var isDesktop, leftPage_1, rightPage_1, book, nextButton_1, arrow, previousButton_1, page_1, buttonToolbar, nextButton_2, arrow, previousButton_2, listener;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    el.innerHTML = "";
                    isDesktop = window.innerWidth >= 1024;
                    if (!isDesktop) return [3 /*break*/, 2];
                    el.classList.remove("single");
                    leftPage_1 = createPageCanvas("left");
                    rightPage_1 = createPageCanvas("right");
                    book = document.createElement("div");
                    book.classList.add("book");
                    book.append(leftPage_1.page, rightPage_1.page);
                    el.append(book);
                    nextButton_1 = document.createElement("div");
                    arrow = document.createElement("img");
                    arrow.src = el.getAttribute("data-arrow-icon") || "";
                    nextButton_1.classList.add("next");
                    nextButton_1.append(arrow);
                    el.append(nextButton_1);
                    previousButton_1 = document.createElement("div");
                    arrow = document.createElement("img");
                    arrow.src = el.getAttribute("data-arrow-icon") || "";
                    previousButton_1.classList.add("prev");
                    previousButton_1.append(arrow);
                    el.prepend(previousButton_1);
                    return [4 /*yield*/, renderPages(pdf, leftPage_1, rightPage_1, currentPage)];
                case 1:
                    _a.sent();
                    nextButton_1.addEventListener("click", function () {
                        currentPage = Math.min(pdf.numPages - 1, currentPage + 1);
                        setButtonStatesMultipage(pdf, currentPage, nextButton_1, previousButton_1, paging);
                        renderPages(pdf, leftPage_1, rightPage_1, currentPage);
                    });
                    previousButton_1.addEventListener("click", function () {
                        currentPage = Math.max(1, currentPage - 1);
                        setButtonStatesMultipage(pdf, currentPage, nextButton_1, previousButton_1, paging);
                        renderPages(pdf, leftPage_1, rightPage_1, currentPage);
                    });
                    setButtonStatesMultipage(pdf, currentPage, nextButton_1, previousButton_1, paging);
                    return [3 /*break*/, 4];
                case 2:
                    page_1 = createPageCanvas("main");
                    el.classList.add("single");
                    el.append(page_1.page);
                    return [4 /*yield*/, renderPage(page_1.canvas, pdf, currentPage)];
                case 3:
                    _a.sent();
                    buttonToolbar = document.createElement("div");
                    buttonToolbar.classList.add("flipbook-navigation");
                    nextButton_2 = document.createElement("div");
                    arrow = document.createElement("img");
                    arrow.src = el.getAttribute("data-arrow-icon") || "";
                    nextButton_2.classList.add("next");
                    nextButton_2.append(arrow);
                    buttonToolbar.append(nextButton_2);
                    previousButton_2 = document.createElement("div");
                    arrow = document.createElement("img");
                    arrow.src = el.getAttribute("data-arrow-icon") || "";
                    previousButton_2.classList.add("prev");
                    previousButton_2.append(arrow);
                    buttonToolbar.prepend(previousButton_2);
                    el.append(buttonToolbar);
                    nextButton_2.addEventListener("click", function () {
                        currentPage = Math.min(pdf.numPages, currentPage + 1);
                        setButtonStates(pdf, currentPage, nextButton_2, previousButton_2, paging);
                        renderPage(page_1.canvas, pdf, currentPage);
                    });
                    previousButton_2.addEventListener("click", function () {
                        currentPage = Math.max(1, currentPage - 1);
                        setButtonStates(pdf, currentPage, nextButton_2, previousButton_2, paging);
                        renderPage(page_1.canvas, pdf, currentPage);
                    });
                    setButtonStates(pdf, currentPage, nextButton_2, previousButton_2, paging);
                    _a.label = 4;
                case 4:
                    listener = function () {
                        console.log("trigger");
                        if (isDesktop !== window.innerWidth >= 1024) {
                            renderBook(pdf, el, paging, currentPage);
                            window.removeEventListener("resize", listener);
                        }
                    };
                    window.addEventListener("resize", listener);
                    return [2 /*return*/];
            }
        });
    });
}
function setButtonStatesMultipage(pdf, currentPage, nextButton, prevButton, paging) {
    nextButton.classList.toggle("disabled", pdf.numPages === currentPage + 1);
    prevButton.classList.toggle("disabled", currentPage === 1);
    paging.innerText = currentPage + "-" + (currentPage + 1) + " / " + pdf.numPages;
}
function setButtonStates(pdf, currentPage, nextButton, prevButton, paging) {
    nextButton.classList.toggle("disabled", pdf.numPages === currentPage);
    prevButton.classList.toggle("disabled", currentPage === 1);
    paging.innerText = currentPage + " / " + pdf.numPages;
}
function renderPages(pdf, _a, _b, startPage, showLoading) {
    var leftCanvas = _a.canvas, leftPage = _a.page;
    var rightCanvas = _b.canvas, rightPage = _b.page;
    if (showLoading === void 0) { showLoading = true; }
    return __awaiter(this, void 0, void 0, function () {
        var renderActions;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (showLoading) {
                        [leftPage, rightPage].forEach(function (page) { return page.classList.add("loading"); });
                    }
                    renderActions = [renderPage(leftCanvas, pdf, startPage)];
                    if (startPage + 1 <= pdf.numPages) {
                        renderActions.push(renderPage(rightCanvas, pdf, startPage + 1));
                    }
                    return [4 /*yield*/, Promise.all(renderActions)];
                case 1:
                    _c.sent();
                    [leftPage, rightPage].forEach(function (page) { return page.classList.remove("loading"); });
                    return [2 /*return*/];
            }
        });
    });
}
function renderPage(canvas, pdf, pageNumber) {
    return __awaiter(this, void 0, void 0, function () {
        var page, viewport, ctx;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, pdf.getPage(pageNumber)];
                case 1:
                    page = _a.sent();
                    viewport = page.getViewport({
                        scale: canvas.clientWidth / page.getViewport({ scale: 1 }).width,
                    });
                    canvas.width = viewport.width;
                    canvas.height = viewport.height;
                    ctx = canvas.getContext("2d");
                    if (ctx === null) {
                        throw new Error("Unable to get canvas context");
                    }
                    return [2 /*return*/, awaitPdfTask(page.render({
                            canvasContext: ctx,
                            viewport: viewport,
                        }).promise)];
            }
        });
    });
}
function awaitPdfTask(pdfTask) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, pdfTask];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
window.addEventListener("load", function () {
    document.querySelectorAll("[data-pdf-view]").forEach(initializeFlipBook);
});
